import * as React from "react";

export const resolveRankByString = (rank: string) => {
	if (rank === 'owner') {
		return (
			<button disabled={true} type="button" className="rank-owner">Majitel</button>
		);
	} else if (rank === 'manager') {
		return (
			<button disabled={true} type="button" className="rank-manager">Manager</button>
		);
	} else if (rank === 'developer') {
		return (
			<button disabled={true} type="button" className="rank-developer">Developer</button>
		);
	} else if (rank === 'adminka') {
		return (
			<button disabled={true} type="button" className="rank-admin">Adminka</button>
		);
	} else if (rank === 'admin') {
		return (
			<button disabled={true} type="button" className="rank-admin">Admin</button>
		);
	} else if (rank === 'helperka') {
		return (
			<button disabled={true} type="button" className="rank-helper">Helperka</button>
		);
	} else if (rank === 'helper') {
		return (
			<button disabled={true} type="button" className="rank-helper">Helper</button>
		);
	} else if (rank === 'eventer') {
		return (
			<button disabled={true} type="button" className="rank-eventer">Eventer</button>
		);
	} else if (rank === 'builder') {
		return (
			<button disabled={true} type="button" className="rank-builder">Builder</button>
		);
	} else if (rank === 'artist') {
		return (
			<button disabled={true} type="button" className="rank-artist">Artist</button>
		);
	} else if (rank === 'obsidian') {
		return (
			<button disabled={true} type="button" className="rank-obsidian">Obsidian</button>
		);
	} else if (rank === 'emerald') {
		return (
			<button disabled={true} type="button" className="rank-emerald">Emerald</button>
		);
	} else if (rank === 'diamond') {
		return (
			<button disabled={true} type="button" className="rank-diamond">Diamond</button>
		);
	} else if (rank === 'gold') {
		return (
			<button disabled={true} type="button" className="rank-gold">Gold</button>
		);
	} else {
		return (
			<button disabled={true} type="button" className="rank-hrac">Hráč</button>
		);
	}
};
